/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_TitleInputs */

const en_common_auth_callback_title = /** @type {(inputs: Common_Auth_Callback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completing sign-in…`)
};

const zh_common_auth_callback_title = /** @type {(inputs: Common_Auth_Callback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在完成登录…`)
};

/**
* | output |
* | --- |
* | "Completing sign-in…" |
*
* @param {Common_Auth_Callback_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_title = /** @type {((inputs?: Common_Auth_Callback_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_title(inputs)
	return zh_common_auth_callback_title(inputs)
});
export { common_auth_callback_title as "common.auth.callback.title" }